<template>
    <div class="section-rentabilidade">
        <!-- <img v-if="isMobile" src="img/Logo Dark.svg" alt="App Logo" class="logo"> -->
		<p v-show="dataInicio && dataFinal">Início {{dataInicio}} até {{dataFinal}}</p>
        <div class="chart-container">
            <div class="chart-header">
                <!-- Filtro de dado desenvolvido porém nunca usado -->
                <div v-if="this.dados.length > 0" class="range-selector">
                    <button v-for="item in filtrosData.filter(d => d.visivel)" :class="{active: item.ativo}" @click="filtrarData(item)" :key="item.key">
                        {{item.label}}
                    </button>
                </div>
            </div>
            <div class="chart" ref="chart"></div>
            <ul class="chart-legend" :key="key">
                <li v-for="(indexador, index) in indexadores.filter(el => !el.escondido)" v-bind:key="index" :class="indexador.escondido ? 'esconder' : ''"
                    @mouseenter="highlightOnChart(indexador.value)" @mouseleave="highlightOnChart(indexador.value, true)">
                    <span class="color" :style="`background-color: ${indexador.cor}`"></span>
                    <p class="name" :title="indexador.value">{{ indexador.value }}</p>
                    <span v-if="!indexador.indexador" class="remove" @click="removerAtivo(indexador)"><img src="img/icons/ico-close.svg"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4lang_pt_BR from "@amcharts/amcharts4/lang/pt_BR"
import ComparadorService from "@/app/services/Comparador/comparador.service"
import ColorsService from '@/app/services/colors.service'
import SpinnerService from '@/app/services/spinner.service'
import moment from 'moment'

export default {
    props: { forcarRenderizacao: { default: 0, type: Number } },
    data() {
        return {
            dataInicio: '',
            dataFinal: '',
            chart: null,
            chartSeriesTransition: false,
            dados: [],
            indexadores: [],
            indexadorAtivo: {},
            legend: '',
            key: 0,
            ultimoTextoTooltip: "",
            filtrosData: [
                { label: '1 ano', dias: 0, meses: 12, visivel: true, ativo: true },
				{ label: '2 anos', dias: 0, meses: 24, visivel: true, ativo: false },
                { label: '3 anos', dias: 0, meses: 36, visivel: true, ativo: false },
                { label: '4 anos', dias: 0, meses: 48, visivel: true, ativo: false },
                { label: '5 anos', dias: 0, meses: 60, visivel: true, ativo: false },
            ]
        }
    },
    methods: {
        filtrarData(item) {
            this.filtrosData.forEach(filtro => {
                filtro.ativo = false
            });
            item.ativo = true

            this.carregarDados().then(() => {
				this.renderizar();
				SpinnerService.hide();
			});
        },
        dataReferenciaFiltro(filtro) {
            let dataReferencia = new Date()
            if (filtro.dias < 0 && filtro.meses < 0) {
                return null
            } else if(filtro.meses > 0) {
                dataReferencia.setMonth(dataReferencia.getMonth() - filtro.meses)
            } else if(filtro.dias > 0) {
                dataReferencia.setDate(dataReferencia.getDate() - filtro.dias)
            }
            dataReferencia.setDate(dataReferencia.getDate() - 1)
            return dataReferencia

        },
        async carregarDados() {
            SpinnerService.show();
            let indexadoresStore = this.$store.getters.getSelecionados;
			let ativosStore = this.$store.getters.getAtivos;
            let idsIndexadores = indexadoresStore.map(el => parseInt(el.codigoIndexador));
			let ids = [...idsIndexadores]
			let periodo = this.filtrosData.find(e => e.ativo).meses/12

			ativosStore.forEach(a => {
				ids.push(Number.parseInt(a.key))
			})

            let retorno = await ComparadorService.obterEvolucaoRentabilidadeGrafico({
                token: this.$route.query.token,
                indexadores: ids,
				periodo: periodo
            });

            if (retorno.sucesso) {
                this.dados = retorno.evolucaoRentabilidade
                // Colocando a carteira no início da array: https://stackoverflow.com/a/36192641
                this.dados.unshift(this.dados.splice(this.dados.findIndex(el => el.nomeAtivo && el.nomeAtivo.toUpperCase() == 'CARTEIRA'), 1).find(() => true))
                this.indexadores = [];
                this.filtrosData.filter(d => !d.visivel).forEach(filtro => {
                    filtro.visivel = false
                });
                retorno.evolucaoRentabilidade.forEach((indexador) => {
                    indexador.indexador = idsIndexadores.includes(indexador.codigoAtivo) || (indexador.nomeAtivo && indexador.nomeAtivo.toUpperCase() == 'CARTEIRA')
                    indexador.isIndexador = idsIndexadores.includes(indexador.codigoAtivo)
                    if (!indexador.nomeAtivo) indexador.nomeAtivo = ''
                    if (!indexador.pontos) indexador.pontos = []
                    this.indexadores.push({
                        key: indexador.codigoAtivo,
                        value: indexador.nomeAtivo,
                        escondido: false,
                        indexador: indexador.indexador,
                        cor: indexador.cor || '#FF0000',
                    })
                    //Liberar filtros
                    indexador.pontos.forEach(element => {
                        let date = new Date(element.data);
                        this.filtrosData.filter(d => !d.visivel).forEach(filtro => {
                            let dataReferencia = this.dataReferenciaFiltro(filtro)
                            if (dataReferencia == null || date < dataReferencia) {
                                filtro.visivel = true
                            }
                        })
                    })
                    this.indexadores.sort((a, b) => b.indexador - a.indexador || a.key - b.key)
                })

                this.indexadores.forEach(item => {
                    item.cor = ColorsService.getIndexadorColor(item.value)
                })

                if (!this.dataInicio || this.dataFinal) {
                    let ativo = retorno.evolucaoRentabilidade.find(() => true)
                    if (ativo) {
                        let first = ativo.pontos[0], last = ativo.pontos[ativo.pontos.length - 1]
                        this.dataInicio = first ? moment(first.data).format('DD/MM/YYYY') : '-';
                        this.dataFinal = last ? moment(last.data).format('DD/MM/YYYY') : '-';
                    }
                }
            }

            SpinnerService.hide();
        },
        renderizar() {
            //SpinnerService.show();

            this.key++;
            if (this.chart) {
                this.chart.dispose();
            }

            let chart = am4core.create(this.$refs.chart, am4charts.XYChart);
            chart.language.locale = am4lang_pt_BR;

            //Loading
            chart.preloader.disabled = true

            let indicator = chart.tooltipContainer.createChild(am4core.Container);
            indicator.background.fill = am4core.color(ColorsService.getCssColorValue('default-bg') || "#FFF");
            indicator.background.fillOpacity = 0.7;
            indicator.width = am4core.percent(100);
            indicator.height = am4core.percent(100);

            let loader = document.querySelector('#loading-template :first-child').outerHTML.replace('sb-color-primary-text', 'sb-color-primary')
            let indicatorLabel = indicator.createChild(am4core.Label);
            indicatorLabel.html = loader;
            indicatorLabel.align = "center";
            indicatorLabel.valign = "middle";
            indicatorLabel.fontSize = 20;

            chart.events.on("ready", function(ev){
                indicator.hide();
            });

            chart.padding(10, 4, 0, 0)
            chart.responsive.enabled = true;
            chart.responsive.useDefault = false;
            // chart.responsive.rules.push({
            //     relevant: am4core.ResponsiveBreakpoints.widthM,
            //     state: function(target, stateId) {
            //         if (target instanceof am4charts.ValueAxis) {
            //             let state = target.states.create(stateId);
            //             return state;
            //         }
            //         return null;
            //     }
            // });
            chart.fontSize = 12;

            let dadosChart = [];
            let menorData;
            let maiorData;
            let filtroselecionado = this.filtrosData.find(d => d.ativo)

            this.dados.forEach(ativo => {
                ativo.pontos.forEach(ponto => {

                    let data = new Date(ponto.data);
                    menorData = menorData ?? data;
                    maiorData = maiorData ?? data;

                    if (data > maiorData) {
                        maiorData = data;
                    }
                    if (data < menorData) {
                        menorData = data;
                    }
                    
                    let inputDado = {};
                    inputDado["date"] = data;
                    inputDado[ativo.nomeAtivo] = ponto.rentabilidade;
                    dadosChart.push(inputDado);
                })
            });

            this.$store.commit("setDatas", {
                maiorData: maiorData,
                menorData: menorData
            });

            chart.data = dadosChart;

            let dateAxis = chart.xAxes.push(new am4charts.DateAxis());;
            dateAxis.tooltip.disabled = true;
            dateAxis.renderer.grid.template.disabled = true;
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.renderer.labels.template.fill = am4core.color(ColorsService.getCssColorValue('text-font-color') || "#000");
            dateAxis.tooltipDateFormat = "dd/MM/yyyy";
            dateAxis.renderer.minGridDistance = 50;
            dateAxis.dateFormats.setKey("month", "MM/yy");
            dateAxis.periodChangeDateFormats.setKey("month", "MM/yy");

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            //valueAxis.title.text = "Rentabilidade %";
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;
            valueAxis.renderer.paddingRight = 26;
            valueAxis.title.text = ''
            valueAxis.renderer.labels.template.adapter.add("text", function(text) {
                return text + "%";
            });
            valueAxis.renderer.labels.template.fill = am4core.color(ColorsService.getCssColorValue('text-font-color') || "#000");

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.behavior = "none";
            //chart.cursor.behavior = "zoomXY";
            //chart.cursor.xAxis = dateAxis;

            //Configuração do tooltip
            chart.plotContainer.tooltipPosition = "pointer";
            chart.plotContainer.tooltipHTML = " ";
            chart.plotContainer.tooltip.getFillFromObject = false;
            chart.plotContainer.tooltip.background.fill = am4core.color(ColorsService.getCssColorValue('default-bg') || "#FFFFFF");
            chart.plotContainer.tooltip.autoTextColor = false;
            chart.plotContainer.tooltip.label.fill = am4core.color(ColorsService.getCssColorValue('text-font-color') || "#000");
            chart.plotContainer.tooltip.background.filters.clear();
            chart.plotContainer.tooltip.background.fillOpacity = 1;


            // let scrollbarX = new am4core.Scrollbar();
            // chart.scrollbarX = scrollbarX;

            for (let i = 0; i < this.indexadores.length; i++) {
                let indexador = this.indexadores[i];

                if (!indexador.escondido) {
                    let color = am4core.color(`${indexador.cor}`);
                    let seriesIndexador = chart.series.push(new am4charts.LineSeries());
                    seriesIndexador.name = indexador.value.toUpperCase();
                    seriesIndexador.dataFields.dateX = "date";
                    seriesIndexador.dataFields.valueY = `${indexador.value}`;
                    seriesIndexador.showOnInit = false;
                    seriesIndexador.strokeWidth = 2;
                    seriesIndexador.stroke = color;
                    this.indexCorAtivo++;

                    // Bullets on hover (Traz inconsistências a tona)
                    // var bullet = seriesIndexador.bullets.push(new am4charts.CircleBullet());
                    // bullet.circle.stroke = color;
                    // bullet.circle.fill = color;
                    // bullet.circle.strokeWidth = 4;
                    // bullet.fillOpacity = 0;
                    // bullet.strokeOpacity = 0;

                    // var bulletState = bullet.states.create("hover");
                    // bulletState.properties.fillOpacity = 1;
                    // bulletState.properties.strokeOpacity = 0.5;

                    // seriesIndexador.bulletsContainer.events.on("over", function(event) {
                    //     processOver(event.target.dataItem.component)
                    // });

                    // seriesIndexador.bulletsContainer.events.on("out", function(event) {
                    //     processOut(event.target.dataItem.component)
                    // });

                    // Setup para evento de destacar linha no hover
                    let segment = seriesIndexador.segments.template;
                    segment.interactionsEnabled = true;

                    let hoverState = segment.states.create("hover");
                    hoverState.properties.strokeWidth = 2;

                    let dimmed = segment.states.create("dimmed");
                    dimmed.properties.stroke = color.saturate(0);
                    dimmed.properties.strokeOpacity = 0.5;

                    segment.events.on("over", function(event) {
                        processOver(event.target.parent.parent.parent);
                    });

                    segment.events.on("out", function(event) {
                        processOut(event.target.parent.parent.parent);
                    });

                    chart.series.push(seriesIndexador);
                }
            }

            // Todo esse esquema de destacar as linhas
            // https://www.amcharts.com/demos/highlighting-line-chart-series-on-legend-hover/
            function processOver(hoveredSeries) {
                hoveredSeries.toFront();

                hoveredSeries.segments.each(function(segment) {
                    segment.setState("hover");
                })

                chart.series.each(function(series) {
                    if (series != hoveredSeries) {
                        series.segments.each(function(segment) {
                            segment.setState("dimmed");
                        })
                        series.bulletsContainer.setState("dimmed");
                    }
                });
            }

            function processOut() {
                chart.series.each(function(series) {
                    series.segments.each(function(segment) {
                        segment.setState("default");
                    })
                    series.bulletsContainer.setState("default");
                });
            }

            chart.cursor.events.on("cursorpositionchanged", (e) => {
                const x = (e.target.chart.xAxes.getIndex(0))
                const y = (e.target.chart.yAxes.getIndex(0))
                if (x && y) {
                    e.target.chart.tooltipHTML = this.obterTextoTooltip(x.positionToDate(x.toAxisPosition(e.target.xPosition)))
                }
            });

            this.chart = chart;
            this.$emit("graficoRenderizado");
            //SpinnerService.hide();
        },
        async ocultarIndexador(nome) {
            SpinnerService.show();

            // Timeout pequeno para que dê tempo do spinner aparecer e travar a tela.
            // É importante para evitar outras ações que possam conflitar com a renderização dos dados no gráfico
            // ex.: deletar um ativo já dentro do this.dados
            setTimeout(() => {
                const indexador = this.indexadores.filter(i => i.value === nome)[0];
                indexador.escondido = !indexador.escondido;

                // Atualizar os indexadores na store para a tabela "Rentabilidade de Índices" carregar novos valores
                let indexadoresStore = this.$store.getters.getIndexadores;
                for (let i = 0; i < indexadoresStore.length; i++) {
                    let indx = this.indexadores.filter(indx => indx.value.toLowerCase().indexOf(indexadoresStore[i].nomeIndexador.toLowerCase()) >= 0)[0];
                    indexadoresStore[i].selecionado = indx !== undefined && !indx.escondido;
                }
                this.$store.commit("setIndexadores", indexadoresStore);

                this.renderizar();
                SpinnerService.hide();
            }, 500);
        },
        obterTextoTooltip(data) {
            if (!data) {
                return "";
            }

            let dadosIndexadores = [];

            try {
                for (let i = 0; i < this.indexadores.length; i++) {
                    let indexador = this.indexadores[i];
                    if (!indexador.escondido) {
                        let dadosIndexador = [];
                        let dadosIndexadorFiltrado = this.dados.filter(d => d.nomeAtivo === indexador.value);

                        for (let j = 0; j < dadosIndexadorFiltrado.length; j++) {
                            const dado = dadosIndexadorFiltrado[j];

                            dadosIndexador = dado.pontos.filter(d => {
                                return moment(d.data).format("YYYY-MM-DD") === moment(data).format("YYYY-MM-DD");
                            });

                            if (dadosIndexador.length) {
                                break;
                            }
                        }
                        if (dadosIndexador.length) {
                            dadosIndexadores.push({
                                key: indexador.key,
                                nome: indexador.value,
                                valor: dadosIndexador[0].rentabilidade,
                                cor: indexador.cor || '#FF0000',
                            });
                        }
                    }
                }
            } catch (ex) { }

            let tooltipText = `<p class="text-center" style="font-size: 10px;">${moment(data).format("DD/MM/YYYY")}</p>`;

            if (dadosIndexadores.length) {
                for (let i = 0; i < dadosIndexadores.length; i++) {
                    const dadoIndexador = dadosIndexadores[i];

                    tooltipText += `<div class="m-0 mb-2 d-flex flex-row justify-content-start align-items-center" style="font-size: 10px;">
                                        <div style="background:${dadoIndexador.cor}; flex: 0 0 8px; height: 8px; width: 8px; border-radius: 50%;"></div>
                                        <span class="mx-2">${dadoIndexador.nome}</span>
                                        <span class="ml-auto">${Number(dadoIndexador.valor).toFixed(2)}%</span>
                                    </div>`
                }

                this.ultimoTextoTooltip = tooltipText;
            } else {
                tooltipText = this.ultimoTextoTooltip;
            }
            return tooltipText;
        },
        removerAtivo(ativo) {
			this.$store.commit('removeAtivo', ativo.key);

            Vue.notify({
                title: 'Sucesso',
                type: "success",
                group: 'principal',
                text: "Ativo removido com sucesso.",
                duration: 5000
            });

            this.$emit('acaoRealizada', 'ativoRemovido');
            this.carregarDados().then(() => {
				this.renderizar();
				SpinnerService.hide();
			});
		},
        highlightOnChart(seriesName, out = false) {
            seriesName = seriesName.toUpperCase();
            let series = this.chart.series.values.find(el => el.name == seriesName);
            if (series) {
                let segment = series.segments.values[0];
                if (segment) {
                    segment.dispatchImmediately(out ? 'out' : 'over')
                }
            }
        }
    },
    computed: {
        indexadoresSelecionados() {
            return this.$store.getters.getSelecionados.map(el => el.id)
        },
        isMobile() {
            return this.$mq == 'mobile'
        },
        temAtualizado() {
            return this.$store.getters.getAtualizado
        },
    },
    watch: {
        temAtualizado(value) {
            if (value) this.renderizar()
        },
        forcarRenderizacao: {
            handler(n, o) {
                this.carregarDados().then(() => {
                    this.renderizar();
                });
            },
            deep: true
        },
        indexadoresSelecionados() {
            let indexadoresStore = this.$store.getters.getIndexadores;

            let selecionados = this.indexadoresSelecionados;

            if (!selecionados || selecionados.length <= 0) {
                selecionados = indexadoresStore
                    .filter(indx => indx.nomeIndexador.toLowerCase() == 'cdi')
                    .map(el => Number.parseInt(el.codigoIndexador))
            }
            
            this.indexadores.forEach(element => {
                if (indexadoresStore.map(d => parseInt(d.codigoIndexador)).includes(element.key)) {
                    element.escondido = !selecionados.includes(element.key)
                }
            });

            this.carregarDados().then(() => {
                this.renderizar();
            });
        }
    },
    beforeMount() {
        moment.locale("pt-BR");

        if (this.opcoes !== undefined) {
            this.options = this.opcoes;
        }
    },
    mounted() {
        this.carregarDados().then(() => {
            this.renderizar();
        });
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
}
</script>

<style lang="scss">
.section-rentabilidade {
    .logo {
        margin-bottom: 24px;
    }

	> p {
		font-size: 14px;
	}

    .chart-container {
        .chart-header {
            display: flex;
            flex-direction: row;
			justify-content: center;
			margin-top: 40px;
            // margin-left: $chart-offset;

            .range-selector {
                width: fit-content;
				padding: 4px;
				background: $box-border-color;
				border-radius: 4px;

                > button {
                    background: transparent;
					border-radius: 4px;
                    border: none;
                    outline: none;
                    margin: 0 12px;
                    padding: 4px 16px;
                    font-size: 12px;
                    line-height: 16px;
                    color: #868686;
                    position: relative;
                    min-width: 66px;

                    &.active {
						color: $main-color;
                        font-weight: 600;
						background: $default-bg;

                        &:before {
                            width: 100%;
                        }
                    }

                    // &:before {
                    //     width: 0;
                    //     content: '';
                    //     position: absolute;
                    //     top: 0; right: 0; bottom: 0; left: 0;
                    //     background: linear-gradient(105.23deg, $main-color 0%, $main-color 100%);
                    //     border-radius: inherit;
                    //     margin: 26px auto 0;
                    //     z-index: -1;
                    //     transition: 1s;
                    // }

                    &:first-child {
                        margin-left: 0;
                    }
                }
            }

            .dates-info {
                width: fit-content;
                margin-left: auto;
                font-size: 12px;
                text-align: right;

                p {
                    margin-bottom: 0;
                    line-height: 125%;
                    color: $sidebar-bg;
                }
            }
        }

        .chart {
            min-height: 350px;
        }

        .chart-legend {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            flex-wrap: wrap;
            margin-top: 24px;
            padding: 0 0 32px;
            // border-bottom: 1px solid rgba(36, 36, 36, 0.35);

            li {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                height: 28px;
                min-width: 70px;
                margin-top: 8px;
                margin-right: 8px;
                padding: 8px 16px;
                background: $box-border-color;
				border-radius: 30px;

                .color {
                    flex: 0 0 8px;
                    height: 8px;
                    width: 8px;
                    border-radius: 100%;
                }

                .name {
                    margin: 0 8px;
                    font-size: 12px;
                    max-width: 120px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .remove {
                    display: flex;
                    margin-left: auto;
                    cursor: pointer;
                    width: 12px;
                    height: 12px;
                }
            }
        }
    }
}

// Mobile
.mobile .section-rentabilidade .chart-container {
    .range-selector {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        > button {
            flex: 1;
            padding: 16px;
        }
    }

    .chart-legend {
        margin-left: 0;
        padding-bottom: 16px;

        li {
            width: 100%;
            margin-right: 0;
        }
    }
}
</style>